/* generated by pull.js */
const manifest = {
  "name": "Extend wrapped C blocks",
  "description": "Makes C blocks extend when wrapping them around blocks, like in Scratch 2.0.",
  "credits": [
    {
      "name": "CST1229",
      "link": "https://github.com/CST1229/"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "tags": ["editor", "codeEditor", "beta"],
  "enabledByDefault": false,
  "dynamicEnable": true,
  "dynamicDisable": true
};
export default manifest;